import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { authTokenVerify, refreshToken } from "./components/redux/api/auth/authApi";

// const ProtectedRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(null);

//   useEffect(() => {
//     const checkAuth = async () => {
//       const resfer = await refreshToken();
//       const isValid = await authTokenVerify();
//       console.log("isValid", isValid);
//       setIsAuthenticated(isValid.verify);
//     };
//     checkAuth();
//   }, []);

//   // if (isAuthenticated === null) {
//   //   return (
//   //     <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
//   //       <div className="spinner-border text-primary" role="status">
//   //         <span className="visually-hidden">Loading...</span>
//   //       </div>
//   //     </div>
//   //   );
//   // }
//   // console.log("auth", token);
//   if (!isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   // Render the children if authenticated
//   return children;
// };

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await refreshToken();
        const isValid = await authTokenVerify();
        setIsAuthenticated(isValid.verify);
      } catch (err) {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
